import api from './api';

export const getAdminStats = async () => {
    const response = await api.get('/api/admin/stats');
    return response.data;
};

export const getAdminRequests = async () => {
    const response = await api.get('/api/admin/requests');
    return response.data;
};

export const getAdminApplications = async () => {
    const response = await api.get('/api/admin/applications');
    return response.data;
};

export const getAdminProjects = async () => {
    const response = await api.get('/api/projects/admin/all');
    return response.data;
};

export const updateApplicationStatus = async (appId, status) => {
    const response = await api.put(`/api/admin/applications/${appId}`, { status });
    return response.data;
};

export const updateMentorRequestStatus = async (requestId, status) => {
    const response = await api.put(`/api/admin/requests/${requestId}`, { status });
    return response.data;
};

export const updateProjectStatus = async (projectId, status) => {
    const response = await api.put(`/api/projects/${projectId}/status`, { status });
    return response.data;
};

export const getMentorStats = async () => {
    const response = await api.get('/api/admin/mentor-stats');
    return response.data;
};

export const getUserStats = async (type = 'all') => {
    const endpoint = type === 'premium' 
        ? '/api/admin/user-stats?type=premium' 
        : '/api/admin/user-stats';
    const response = await api.get(endpoint);
    return response.data;
};
